import { PersonRoleDTO, UserDTO } from '@auto-generated/ap-platform/users';
import { RegistrationRequestDTO } from '@auto-generated/ap-platform/care-providers';

export class UserUtils {
	public static getName(user: UserDTO | RegistrationRequestDTO): string {
		return `${user.firstName ? user.firstName : ''} ${user.lastName ? user.lastName : ''}`;
	}

	public static getCurrentPersonRole(user: UserDTO, currentPid: number): PersonRoleDTO {
		return user?.personRoles.find(item => item.personId === currentPid);
	}
}
